import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { conversations as convApi } from "../lib/api";

export const MessagesIcon = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const timer = useRef(null);

  const fetchCount = useCallback(async () => {
    try {
      const r = await convApi.unreadCount();
      setCount(r.data?.unread_count ?? r.data?.count ?? 0);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    fetchCount();
    timer.current = setInterval(fetchCount, 20000);
    return () => clearInterval(timer.current);
  }, [fetchCount]);

  return (
    <button
      onClick={() => navigate("/messages")}
      className="relative p-2 rounded-md text-[#999] hover:text-white hover:bg-[#252525] transition-colors"
      data-testid="messages-icon-btn"
      aria-label="Messagerie"
    >
      <MessageCircle className="w-5 h-5" />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#4ECDC4] text-[#0a0a0a] text-[10px] font-bold flex items-center justify-center" data-testid="messages-badge">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
};

export default MessagesIcon;
